import { useContext, useEffect, useState } from 'react';

import { useGetFinancialStatisticsBySearchIdQuery } from '@app/api/Analytics';
import { useUserPrint } from '@app/hooks';
import { HeaderContext, NotificationContext } from '@app/providers';
import type { NSearchIdProvider } from '@app/providers/SearchIdProvider/SearchIdProvider.types';
import { handleCatchError } from '@app/services';
import type { NAnalytics } from '@app/types';

export const useRecordsPageHeader = () => {
  const [financialStatistics, setFinancialStatistics] =
    useState<NAnalytics.ModelFinancialStatistic>();

  const { activeBranchId } = useUserPrint();

  const { showNotification } = useContext(NotificationContext);
  const { header } = useContext(HeaderContext);

  const { data, error, refetch } = useGetFinancialStatisticsBySearchIdQuery(
    {
      searchId: header.searchId as NSearchIdProvider.SearchId,
      ActiveBranchId: activeBranchId,
    },
    {
      skip: !header.searchId || !activeBranchId,
    }
  );

  useEffect(() => {
    setFinancialStatistics(data);
  }, [data]);

  useEffect(() => {
    if (error) {
      showNotification(handleCatchError(error));
    }
  }, [error, showNotification]);

  return {
    financialStatistics,
    refetchFinancialStatistics: refetch,
  };
};
